
import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';

import BookCard from '../BookCard';
import CardShelf from '../CardShelf';

import './BookShelf.scss';
import { gaReadSource } from '../../lib/constants';

const renderBookEls = (t, books, onReadClicked, isFetchingAssets, sectionClicked, offline, readSource, isRtl, isTargetLangAvailable, isFromMobileTranslate, isDraftLoading, userType, profileType, triggerEvent, onTriggerEvents, isOfflineStem, eventCategory, eventLabel, hideAllIcons, hideQuickViewBtn, overrideReaderClick) => {

  return books.map(book => {
    return <BookCard 
        key={book.id} 
        book={book}
        sectionClicked={sectionClicked} 
        offline={offline}
        onClick={overrideReaderClick ? ()=>onReadClicked(book) : onReadClicked}
        isTargetLangAvailable={isTargetLangAvailable}
        isFromMobileTranslate={isFromMobileTranslate}
        isDraftLoading={isDraftLoading}
        hideMenu={!isOfflineStem}
        customMenu = {isOfflineStem}
        hideReadCountStat={isOfflineStem}
        hideQuickViewBtn={(readSource === gaReadSource.stem) || hideQuickViewBtn}
        hideAllIcons = {(readSource === gaReadSource.stem && !isOfflineStem) || hideAllIcons}
        shouldShowReadIcon={isOfflineStem}
        readSource={readSource}
        isRtl={isRtl}
        originalAuthors={book.original_authors}
        profileType={profileType}
        userType={userType}
        eventCategory={eventCategory}
        eventLabel={eventLabel}
        loading={isFetchingAssets}
      />;
  });
};

@translate()
class BookShelf extends Component {
  static defaultProps = {}

  render() {
    const {
      books,
      onReadClicked,
      isFetchingAssets,
      viewport,
      t,
      sectionClicked,
      offline,
      readSource,
      isDraftLoading,
      isTargetLangAvailable,
      isFromMobileTranslate,
      isRtl,
      id,
      popoutControls,
      cardsInFrame,
      profileType,
      userType,
      isOfflineStem,
      triggerEvent,
      onTriggerEvents,
      eventCategory,
      eventLabel,
      hideAllIcons,
      hideQuickViewBtn,
      overrideReaderClick
    } = this.props;

    const baseClassName = 'pb-book-shelf';

    const classes = {
      [baseClassName]: true
    };

    return (
      <div className={classNames(classes)}>
        <CardShelf cellWidth="book-card" viewport={viewport} id={id} isRtl={isRtl} popoutControls={popoutControls} cardsInFrame={cardsInFrame}>
          {renderBookEls(t, books, onReadClicked, isFetchingAssets, sectionClicked, offline, readSource, isRtl, isTargetLangAvailable, isFromMobileTranslate, isDraftLoading, userType, profileType, triggerEvent, onTriggerEvents, isOfflineStem, eventCategory, eventLabel, hideAllIcons, hideQuickViewBtn, overrideReaderClick)}
        </CardShelf>
      </div>
    );
  }
}

BookShelf.propTypes = {
  viewport: PropTypes.object.isRequired,
  books: PropTypes.arrayOf(PropTypes.shape(BookCard.propTypes)).isRequired
};

export default BookShelf;



// WEBPACK FOOTER //
// ./src/components/BookShelf/BookShelf.jsx